import { useSyncExternalStore } from 'react';

interface ClientOnlyProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const subscribe = () => () => {};

// Renders children only in the browser. The server render and hydration use the fallback, so code
// that reads window or localStorage while rendering never runs on the server.
const ClientOnly = ({ children, fallback = null }: ClientOnlyProps) => {
  const isClient = useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );

  return isClient ? children : fallback;
};

export default ClientOnly;
